// ─────────────────────────────────────────────────────────────────────────────
// Buckly design tokens — TAKEN FROM THE DESIGN, not chosen.
//
// Source: the Claude Design project archive, Buckly.dc.html (B-0 run 2, sha256
// d689b743…c569 for the archive). Owner rulings R21 / R40: her page wears the
// Claude Design look inside the desktop, fonts and background included (U1).
//
// THE FAMILY NAMES ARE BUCKLY'S OWN. The design asks for 'Inter' and
// 'JetBrains Mono'. Both names are already used elsewhere in the desktop
// (missioncontrol/theme.ts, lib/mackFlowCore.js) where they resolve to whatever
// the machine has. An @font-face under those names would be document-global and
// silently restyle GROWTH and Mack's Flow tab, so the vendored files are
// registered as 'Buckly Inter' / 'Buckly JetBrains Mono' and sx() maps the
// design's names onto them. Nothing outside Buckly's page can reach them.
// ─────────────────────────────────────────────────────────────────────────────

import type React from 'react';

export const FONT_ALIASES: ReadonlyArray<[string, string]> = [
  ["'Inter'", "'Buckly Inter'"],
  ["'JetBrains Mono'", "'Buckly JetBrains Mono'"],
];

// The design's page ground (Buckly.dc.html:16, :22, :25).
export const PAGE_BG = '#04060e';
export const PAGE_TEXT = '#e8eef0';
export const SANS = "'Buckly Inter',system-ui,sans-serif";

// The design page inherits the browser's defaults; the desktop's body does not
// (index.css: line-height 1.55, letter-spacing 0.01em, optimizeLegibility). Her
// page restores the defaults for HER SUBTREE ONLY, so the design's type metrics
// (every line box, every text width) are the design's. Nothing outside changes.
export const DESIGN_GROUND: React.CSSProperties = {
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textRendering: 'auto',
};

// ── The desktop's corner orb ──────────────────────────────────────────────────
// The orb is a fixed 160×160 tap-to-talk control, 16px from the right and 88px
// from the top by default (shell/CornerOrb.tsx:30-53, zIndex 11). At rest the
// design's header puts Reset and the status line exactly there, so pressing Reset
// would press the orb and start a call (R41: no call to Buckly before B-2). The
// header row alone keeps clear of that box: 16 + 160 + 8px gap from the window's
// right edge, less the 40px body padding and whatever the centred 1640px column
// already leaves. 0 on any window wide enough for the design to miss the orb.
export const ORB_CLEARANCE = 'max(0px, calc(144px - max(0px, (100vw - 1640px) / 2)))';

// ── Her background, dulled (owner, round B-1b) ────────────────────────────────
// NOT FROM THE DESIGN. Matt, on the landed page: "the background image needs to
// be duller, as in its too bright". The design's starfield (assets/buckly-bg.png,
// unchanged) is dimmed on its own layer only, by a CSS filter; text, panels and
// every other page are untouched. 0 = the image as drawn, 1 = black: darker by
// BUCKLY_BG_DIM and less saturated by half as much, so one value moves both.
// Nudge THIS value only — up for darker, down for lighter.
export const BUCKLY_BG_DIM = 0.5;
export const BUCKLY_BG_FILTER = `brightness(${1 - BUCKLY_BG_DIM}) saturate(${1 - BUCKLY_BG_DIM / 2})`;
